<template>
  <el-dialog
    title="其他操作"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="35%"
    @close="handleClose"
  >
    <ul class="operate-header">
      <li>
        <span class="label">T3： </span>
        <span class="value">{{ detailObj.branch }}</span>
      </li>
      <li>
        <span class="label">T4： </span>
        <span class="value">{{ detailObj.area }} </span>
      </li>
      <li>
        <span class="label"> 姓名： </span>
        <span class="value">{{ detailObj.accountName }}</span>
      </li>
    </ul>
    <el-form :model="form" ref="formRef" :rules="rules" label-width="80px">
      <el-form-item label="作废环节" prop="step">
        <el-radio-group v-model="form.step" size="small">
          <el-radio
            border
            v-for="(ite,idx) in stateList"
            :key="idx"
            :label="ite.value"
          >{{ ite.label }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="作废原因" prop="cancelReason">
        <el-checkbox-group v-model="form.cancelReason">
          <el-checkbox v-for="(item,index) in resonList" :key="index" :label="item.label"/>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item v-if="form.cancelReason.includes('其他')"  prop="cancelDetail">
        <el-input
          v-model="form.cancelDetail"
          placeholder="请输入原因"
          :rows="4"
          maxlength="200"
          type="textarea"
        ></el-input>
      </el-form-item>
      <div class="btns">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>
        
<script>
import url from "@/modules/url";
import api from "@/modules/api";
import { Options } from '@/components/utils/fixOptions'
export default {
  data() {
    return {
      dialogVisible: true, // 控制对话框的显示与隐藏
      form: {
        step: '',
        cancelReason: [],
        cancelDetail: "",
      },
      resonList: Options.cancel_reason,
      stateList: Options.step_status.slice(0, 3),
      rules: {
        step:[
          { required: true, message: '请选择招募安排阶段', trigger: 'change' }
        ],
        cancelReason:[
          { required: true, message: '请选择作废原因', trigger: 'change' }
        ],
        cancelDetail:[
          { required: true, message: '请输入原因', trigger: 'blur' }
        ]
      }
    };
  },
  props: {
    detailObj: {
      type: Object,
      default: {}
    },
  },
  mounted() {
  },
  methods: {
    getStaffInfo(){},
    // 提交表单
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {                    
          if (this.form.step != this.detailObj.step) {
            this.$message.error("当前候选人还未完成所选阶段，请知悉");
            return false;
          } 
          let stepLabel = this.stateList.find(item => item.value == this.form.step).label
          this.$confirm('确定要撤销' + this.detailObj.accountName + '的' + stepLabel + '操作么？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => { 
            const { step, cancelReason,cancelDetail } = this.form
            const data = {
              userId: this.detailObj.userId,     
              step: step,
              reasons: cancelReason,
              reasonDesc: cancelDetail
            }
            this.save(data)
          });
        } else {
          this.$message.error("表单验证失败");
          return false;
        }
      });
    },
    save(data){
      console.log("提交成功", data);
      api.post(url.cancelInterview, data, (res) => {
        if (res.result.isSuccess) {
          this.handleClose("refresh");
        } else {
          if (res.result.errors.length > 0) {
            this.$message({
              type: 'error',
              message: res.result.errors[0].errorCode + res.result.errors[0].error
            });
          } else {
            this.$message({
              type: 'error',
              message: res.result.error
            });
          }
        }
      });
    },
    handleClose(flag="") {
      this.form = {
        cancelReason: [],
        cancelDetail: "",
      };
      this.$emit("close");
      flag == 'refresh' && this.$emit("refresh")
    },
  },
};
</script>
      
<style lang="scss" scoped>
.btns {
  text-align: center;
}
.el-radio {
  margin-right: 10px !important;
}
.operate-header {
  margin: 0;
  padding: 0;
  display: flex;
  flex-flow: wrap;
  width: 100%;
  margin-bottom: 15px;
  li {
    width: 50%;
    list-style: none;
    padding: 10px 0;
    .label {
      display: inline-block;
      width: 80px;
      text-align: right;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/recruit/officeSaff/component/operateDialog.vue